import utils from '@/utils/common'

const getNotificationUrl = notification => {
  const {
    __typename, task, board, verificationAction,
  } = notification.notification

  if (task) return `/project-management/board/${utils.base58Converter(task.board.uuid)}/tasks/${utils.base58Converter(task.uuid)}`
  if (board) return `/project-management/board/${utils.base58Converter(board.uuid)}`

  switch (__typename) {
  case 'NotificationFinalizePayment':
  case 'NotificationWalletAction':
  case 'NotificationWalletTransferAction':
    return '/accounts'
  case 'NotificationInvoiceVerification':
    if (verificationAction !== 'REQUESTED') return '/payments'
    return null
  case 'NotificationWalletShareInvite':
    if (verificationAction !== 'REQUESTED') return '/accounts'
    return null
  default:
    return null
  }
}

export default notification => getNotificationUrl(notification)
